import { Page, DatePicker, FormGroup as UpdateForm } from 'components/common';
import React, { useState, useEffect, useRef, useMemo } from 'react';
import { Trans } from 'react-i18next';
import { NotificationManager } from 'react-notifications';
import {
  Table,
  Button,
  Modal,
  ModalHeader,
  ModalFooter,
  Input as AccInput,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  DropdownToggle,
  Label
} from 'reactstrap';
import BackButton from 'components/refactoring/BackButton';
import { useOrganisationContext, useUserContext } from "hooks";
import { ApiClient, } from "services";
import { Control, LocalForm, actions } from 'react-redux-form';
import { compose, withHandlers, withPropsOnChange } from 'recompose';
import onMount from 'components/common/onMount';
import { withDefaultReportParams } from '../hooks/useDefaultReportParams';
import { range } from 'lodash';
import moment from 'moment';
import { formatDate, formatNumber, handleFilesCountUpdate } from 'services/util';
import SubmitButton from 'components/common/Forms/SubmitButton';
import Select from 'react-select';
import {
  useForm,
  FormProvider,
  useFieldArray,
  useWatch,
} from "react-hook-form";

import {
  FormGroup,
  Input,
} from "components/react-hook-form";
import InputFilesForm from 'components/common/InputFilesForm';

const AuditRequirements = ({ t, match, item: itemProp, data, timeframes, setState, periods, handleFilterSubmit }) => {
  const [item, setItem] = useState(itemProp);

  const classes = [
    { id: 1, name: 'Asset', expanded: false },
    { id: 2, name: 'Liability', expanded: false },
    { id: 3, name: 'Equity', expanded: false },
    { id: 4, name: 'Expense', expanded: false },
    { id: 5, name: 'Revenue', expanded: false },
  ]

  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownMenuRef = useRef(null);
  const toggleDropdown = () => setDropdownOpen(!dropdownOpen);

  const [accountsModal, setAccountsModal] = useState(false);
  const [currentRow, setCurrentRow] = useState(null);
  const [selectedAccounts, setSelectedAccounts] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [auditDateRange, setAuditDateRange] = useState();
  const [uploadedFilesCount, setUploadedFilesCount] = useState([]);
  const [balanceDifference, setDifference] = useState(0);

  const { selectedOrganisation } = useOrganisationContext();
  const { user } = useUserContext();
  const client = ApiClient();

  const auditor_permission = useMemo(() => {
    return user?.permissions?.includes("access_audit_report");;
  }, [user?.permissions]);

  const year_id = match.params.id;
  const differences = [];

  const methods = useForm({
    mode: "onBlur",
  });
  const { reset, control, setValue, handleSubmit, watch, getValues } = methods;

  const { fields, remove, append } = useFieldArray({
    control,
    name: "account_file",
    keyName: "key",
  });

  const count_progress = useWatch({
    control,
    defaultValue: {
      account_file: fields //not using name of the useFieldArray and using defaultValues to calculate the difference and display the fields according to the updated date from balance sheet filter. reset the values upon filtering the balance sheet. see handleFilterChange function for reference 
    }
  });

  const progress = useMemo(

    () => (formatNumber((count_progress?.account_file?.filter(item => item?.audit_requirements_account?.length > 0)?.length / count_progress?.account_file?.length) * 100, "0.0")) || 0,
    [count_progress]
  );

  useEffect(() => {
    if (count_progress?.account_file?.length > 0) {
      count_progress?.account_file?.map((element) => {
        const difference = parseFloat(element?.balance_in_ADD) - parseFloat(element?.balance_in_files)
        differences.push(difference);
      });
      setDifference(differences);
    };
  }, [count_progress, fields]);

  useEffect(() => {
    fetchData();
    fetchAllFilesData();
    document.addEventListener('mousedown', handleOutsideClick);
    return () => {
      document.removeEventListener('mousedown', handleOutsideClick);
    };
  }, []);



  useEffect(() => {
    handleFilterChange();
  }, [data]);

  const handleOutsideClick = (e) => {
    if (dropdownMenuRef?.current && !dropdownMenuRef.current.contains(e.target)) {
      setDropdownOpen(false);
    }
  };

  const accountsToggleModal = () => setAccountsModal(!accountsModal);


  const handleAccounts = (row) => {
    setCurrentRow(row);
    setSelectAll(false);
    setAccountsModal(true);
  };

  const saveSelectedAccounts = () => {

    const updatedRows = classes
      .filter(row => row?.id === currentRow?.id)
      .flatMap(row => {
        return account_values
          .filter(account => selectedAccounts.includes(account?.id))
          .map(account => {
            const final_v = fileName.some(keyword => account?.Title?.includes(keyword))
              ? account
              : null;

            return final_v ? {
              ...row,
              Title: final_v?.Title,
              account_name: final_v?.tName,
              balance_in_ADD: final_v?.tValue,
              AccountID: final_v?.tId
            } : null;
          }).filter(row => row !== null);
      });

    updatedRows.forEach(row => {
      append({
        account_name: row.account_name || "",
        Title: row.Title || "",
        balance_in_ADD: row.balance_in_ADD || null,
        balance_in_files: row.balance_in_files || null,
        difference: row.difference || null,
        account_id: row?.AccountID,
        account_class: currentRow?.name,
        audit_requirements_account: row?.audit_requirements_account || [],
      });
    });
    setAccountsModal(false);
    setSelectedAccounts([]);
  };

  const findAccountDetails = (accountId) => {
    const selectedClass = classes.find((cls) => cls.id === currentRow.id);

    if (!selectedClass) return null;

    const selectedAccount = account_values.find((account) => account?.id === accountId);

    if (!selectedAccount) return null;

    return {
      accountId: selectedAccount?.tId,
      accountName: selectedAccount?.tName
    };
  };
  const handleAccountSelect = (accountId, e) => {
    e.stopPropagation();

    setSelectedAccounts(prevSelected =>
      Array.isArray(prevSelected)
        ? prevSelected.includes(accountId)
          ? prevSelected.filter(id => id !== accountId)
          : [...prevSelected, accountId]
        : [accountId]
    );
  };

  const handleRemoveAccount = (account) => {
    const accountId = account?.id ? account.id : account;

    setSelectedAccounts(prevSelected => prevSelected.filter(id => id !== accountId));
  };

  const fileName =
    currentRow?.name === "Asset" ? ["Assets", "Current Assets", "Fixed Assets", "Bank"] :
      currentRow?.name === "Liability" ? ["Current Liabilities", "Liabilities", "Non-Current Liabilities"] :
        [currentRow?.name]


  const handleSelectAll = () => {
    if (selectAll) {
      setSelectedAccounts([]);
    } else {

      const allAccounts = account_values?.filter((account) => fileName?.some(keyword => account?.Title?.includes(keyword)));

      setSelectedAccounts(allAccounts.map(acc => acc?.id));
    }
    setSelectAll(!selectAll);
  };

  const balanceSheet = data

  const fetchData = async () => {

    try {
      const audit_date_range = await client.get(`/audit_reports/${selectedOrganisation.id}/date_range/${year_id}`);
      setAuditDateRange(audit_date_range.data);
    } catch (error) {
      NotificationManager.error(error?.response?.data?.error || t("Something went wrong"));
    }
  };
  const handleUpdateDateRange = async (values) => {
    const payload = {
      start_date: values.start_date,
      deadline: values.deadline,
      selected_year: year_id
    };

    try {
      const response = await client.put(`/audit_reports/${selectedOrganisation.id}/date_range/${year_id}/update_date_range`, payload);
      NotificationManager.success(t("Updated successfully"));
    } catch (error) {
      NotificationManager.error(error?.response?.data?.error || t("Something went wrong"));
    }
  };

  const sectionBalance = useMemo(() => {
    return balanceSheet?.Rows?.filter(row => row.RowType === 'Section');

  }, [balanceSheet?.Rows]);



  let idCounter = 1
  const summaryRowBalance = useMemo(() => {
    return sectionBalance
      ?.flatMap(sectionItem => {
        return sectionItem.Rows.filter(row => {
          return row.RowType === 'Row';
        })
          .map(row => {
            return {
              Title: sectionItem.Title,
              tName: row.Cells[0]?.Value,
              tValue: row.Cells[1]?.Value,
              tId: row.Cells[0]?.Attributes?.[0]?.Value,
              id: idCounter++
            };
          });
      });
  }, [sectionBalance]);

  const account_values = useMemo(() => {
    return summaryRowBalance;
  }, [summaryRowBalance]);

  const fetchAllFilesData = async () => {

    try {
      const files_data = await client.get(`/audit_reports/${selectedOrganisation.id}/audit-requirements/${year_id}`);

      files_data.data?.account_file.map(_account_file => {
        const account = account_values?.find(account => account?.tId === _account_file?.account_id);
        _account_file.account_name = account?.tName;
        _account_file.Title = account?.Title;
      });
      reset(files_data.data);
    } catch (error) {
      NotificationManager.error(error?.response?.data?.error || t("Something went wrong"));
    }
  };


  const handleAuditRequirementsSubmit = async (form_values) => {
    console.log(form_values, "??? form values");

    if (form_values.account_file?.length === 0) {
      NotificationManager.warning(t("Please select at least 1 account and put the values to proceed."));
      return;
    };
    let balanceWarningShown = false;

    form_values?.account_file?.map(_account_file => {

      if (!_account_file.balance_in_files && !balanceWarningShown) {
        balanceWarningShown = true;
        return;
      }
    });

    if (balanceWarningShown) {
      NotificationManager.warning(t("Missing balance in files value."));
      return;
    };

    try {
      const payload = {
        progress: progress,
        audit_reports_add_year: parseInt(year_id),
        account_file: form_values.account_file
      };

      const response = await client.post(`/audit_reports/${selectedOrganisation.id}/audit-requirements`, payload);
      const id = response?.data?.id;
      NotificationManager.success(t("Saved successfully"));
      setTimeout(() => {
        window.location.replace(`/reports/audit_reports/audit_requirements/${year_id}/${id}`);
      }, 200);

    } catch (error) {
      NotificationManager.error(error?.response?.data?.error || t("Something went wrong"));
    }
  };

  const handleFilterChange = () => {

    for (let key in account_values) {
      const account = account_values[key];

      const field = fields.find(f => f?.account_id === account?.tId);
      if (field) {
        field.balance_in_ADD = account?.tValue;
        reset({ account_file: fields });
      };
    };

  };


  return (
    <Page title="Add Audit Requirements">
      <div className='d-flex justify-content-between align-items-center'>
        <BackButton />
      </div>
      <div className='mb-4 border'>
        <div className='my-2 ml-2'>
          <span><Trans><strong>Filter Balance Sheet</strong></Trans></span>
        </div>
        <div className='my-2 ml-2'>
          <LocalForm
            className="d-print-none"
            getDispatch={(dispatch) => setState({ dispatch })}
            onSubmit={handleFilterSubmit}
            onChange={setItem}
            initialState={item}
          >
            <div className="d-flex align-items-center">
              <UpdateForm label="Date" className="mr-3">
                <DatePicker model=".date" className="form-control" />
              </UpdateForm>
              <UpdateForm label="Periods" className="mr-3" addControlClass={false}>
                <Control.select
                  component={Select}
                  simpleValue
                  style={{ minWidth: "10rem", backgroundColor: '#F4F7FE' }}
                  options={periods}
                  searchable={false}
                  model=".periods"
                />
              </UpdateForm>
              <UpdateForm label="Time frame" className="mr-3" addControlClass={false}>
                <Control.select
                  component={Select}
                  simpleValue
                  style={{ minWidth: "10rem", backgroundColor: '#F4F7FE' }}
                  options={timeframes}
                  searchable={false}
                  model=".timeframe"
                />
              </UpdateForm>
              <UpdateForm label="&nbsp;" className="mr-3">
                <UpdateForm label="Cash transactions only" check>
                  <Control.checkbox model=".paymentsOnly" />
                </UpdateForm>
              </UpdateForm>
              <UpdateForm label="&nbsp;">
                <SubmitButton size="sm" className="d-block">
                  <Trans>Update</Trans>
                </SubmitButton>
              </UpdateForm>
            </div>
          </LocalForm>
        </div>
      </div>
      <div className='my-2' />
      <div className=" border ">
        <div className="my-4 ml-2 mr-2 ">
          {auditDateRange &&
            <>
              <LocalForm initialState={auditDateRange} onSubmit={handleUpdateDateRange}>
                <div className='d-flex justify-content-start mr-3'>
                  <UpdateForm label="Company Name" className='mr-3'>
                    <Control.text
                      model=".connectedsation"
                      className="form-control"
                      style={{ backgroundColor: '#F4F7FE' }}
                      readOnly
                      defaultValue={selectedOrganisation?.name}
                    />
                  </UpdateForm>
                  <UpdateForm label="Audit start date" className='mr-3'>
                    <DatePicker
                      type="date"
                      className="form-control"
                      model=".start_date"
                      placeholder="Start Date"
                      disabled={auditor_permission === false}
                    />
                  </UpdateForm>
                  <UpdateForm label="Deadline" className='mr-3'>
                    <DatePicker
                      type="date"
                      className="form-control"
                      model=".deadline"
                      placeholder="Deadline"
                      disabled={auditor_permission === false}
                    />
                  </UpdateForm>
                  <UpdateForm label="&nbsp;" className='mr-3'>
                    <Button disabled={auditor_permission === false} size='md' color="primary" type="submit"><Trans>Update</Trans></Button>
                  </UpdateForm>
                </div>
              </LocalForm>
              <div className='my-2 d-flex justify-content-start align-items-center'>
                <div className='mt-2'>
                  <Label><strong><Trans>Audit period end date</Trans></strong></Label>
                </div>
                <div className='ml-2'>
                  {auditDateRange?.end_date}
                </div>
              </div>
            </>
          }
          {progress > 0 ? (
            <div className="progress my-3 h-50">
              <div className="progress-bar h-50 progress-bg-clr" role="progressbar" style={{ width: `${progress}%` }}>
                {progress}%
              </div>
            </div>
          ) :
            <div className="progress my-3 h-50">
              <div className="progress-bar h-50 progress-bg-clr" role="progressbar" style={{}}>
                {0}%
              </div>
            </div>
          }

          <FormProvider {...methods} >
            <Table >
              <thead>
                <tr>
                  <th className='table_fontsize'><Trans>File Name</Trans></th>
                  <th></th>
                  <th></th>
                  <th><Trans>Accounts</Trans></th>
                  {/* <th></th> */}
                </tr>
              </thead>
              <tbody>
                {classes.map((acc_class, index) => {
                  return (
                    <>
                      <tr key={acc_class.key}>
                        <td className='table_fontsize'>{acc_class?.name}</td>
                        <td></td>
                        <td></td>
                        <td><Button color="primary" className='fa fa-folder' onClick={() => handleAccounts(acc_class)}></Button></td>
                      </tr>
                      {fields.some(element => element.account_class === acc_class.name) &&
                        <tr>
                          <td colSpan={8} className='audit-td'>
                            <Table size='lg'>
                              <thead>
                                <tr>
                                  <th><Trans>Selected Account Name</Trans></th>
                                  <th><Trans>Title</Trans></th>
                                  <th><Trans>Valid</Trans></th>
                                  <th><Trans>Upload</Trans></th>
                                  <th><Trans>Balance</Trans></th>
                                  <th><Trans>Balance in Files</Trans></th>
                                  <th><Trans>Difference</Trans></th>
                                  <th><Trans>Actions</Trans></th>
                                </tr>
                              </thead>
                              <tbody>
                                {fields
                                  .map((field, idx) => {
                                    const n = (v) => `account_file.${idx}.${v}`;

                                    if (field.account_class === acc_class.name)
                                      return (
                                        <tr key={field?.id} className='mt-2'>
                                          <td className='table_fontsize'>{field?.account_name}</td>
                                          <td className='table_fontsize'>{field?.Title}</td>
                                          <td className="text-center">
                                            <FormGroup className="d-flex justify-content-center align-items-center">
                                              <Input
                                                type='checkbox'
                                                name={n("is_required")}
                                                checked={getValues(n("is_required"))}
                                                disabled={auditor_permission === false}
                                              />
                                            </FormGroup>
                                          </td>
                                          <td>
                                            <FormGroup>
                                              <InputFilesForm t={t} name={n(`audit_requirements_account`)} setValue={setValue} control={control} onFilesCountUpdate={(count) => handleFilesCountUpdate(count, setUploadedFilesCount, idx)} uploadedFilesCount={uploadedFilesCount[idx] || 0} auditor_permission={auditor_permission}></InputFilesForm>
                                            </FormGroup>
                                          </td>
                                          <td className='table_fontsize'>
                                            {field?.balance_in_ADD}
                                          </td>
                                          <td>
                                            <FormGroup>
                                              <Input
                                                type="number"
                                                className="form-control"
                                                name={n("balance_in_files")}
                                                placeholder={t("Balance in file")}
                                              />
                                            </FormGroup>
                                          </td>
                                          <td>
                                            <div className={` ${field?.difference && field?.difference < 0 ? "bg-danger text-white px-3 rounded-pill" : balanceDifference && balanceDifference[idx] < 0 ? "bg-danger text-white px-3 rounded-pill" : "bg-success text-white px-3 rounded-pill"} text-white`}>
                                              {field?.difference !== undefined && field?.difference !== null
                                                ? isNaN(balanceDifference[idx]) ? 0 : balanceDifference[idx]?.toFixed(2)
                                                : (balanceDifference && balanceDifference?.length > 0 && !isNaN(balanceDifference[idx])
                                                  ? balanceDifference[idx]?.toFixed(1)
                                                  : 0
                                                )
                                              }
                                            </div>
                                          </td>
                                          <td>
                                            <div className="d-flex justify-content-center align-items-center">
                                              <Button color="danger" onClick={() => remove(idx)}><i className='fa fa-trash'></i></Button>
                                            </div>
                                          </td>
                                        </tr>
                                      );
                                  })}
                              </tbody>
                            </Table>
                          </td>
                        </tr>
                      }
                    </>
                  )
                })}
              </tbody>
            </Table>
            <FormGroup className="text-right">
              <Button type="submit" color='primary' onClick={handleSubmit(handleAuditRequirementsSubmit)}><Trans>Save</Trans></Button>
            </FormGroup>
          </FormProvider>
        </div>
      </div>
      <Modal isOpen={accountsModal} toggle={accountsToggleModal}>
        <ModalHeader toggle={accountsToggleModal}><Trans>Balance Sheet Accounts</Trans></ModalHeader>
        <div className="container">
          <div className='mt-2 ml-2 container'>
            <span>
              <Trans>
                Please select the accounts that you want to include in the audit report
              </Trans>
            </span>
          </div>
          <div className='col mt-3 mb-4'>
            <div className="">
              <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown} >
                <DropdownToggle outline="true" className='audit_report_files_color' caret>Select Accounts</DropdownToggle>
                {dropdownOpen && (
                  <DropdownMenu style={{ maxHeight: '200px', overflowY: 'auto' }}>
                    <div className="show" >
                      <DropdownItem>
                        <div className="py-0 pl-3" onClick={handleSelectAll}>
                          <AccInput
                            type="checkbox"
                            checked={selectAll}
                            readOnly
                          />
                          <div><Trans>Select All</Trans></div>
                        </div>
                      </DropdownItem>

                      {account_values
                        .filter((account) => fileName.some(keyword => account?.Title?.includes(keyword))
                        )
                        .map((account, idx) => (
                          <DropdownItem>
                            <div className="py-0 pl-3 border-none" key={idx} onClick={(e) => handleAccountSelect(account?.id, e)}>
                              <AccInput
                                type="checkbox"
                                checked={selectedAccounts?.includes(account?.id)}
                                readOnly
                              />
                              <span className='clickable'>{account?.tName}</span>
                            </div>
                          </DropdownItem>
                        ))}
                    </div>
                  </DropdownMenu>
                )}
              </Dropdown>

              <div className="ml-2 mt-2">
                {selectedAccounts?.map((accountId, idx) => {
                  const accountDetails = findAccountDetails(accountId);

                  if (!accountDetails) return null;

                  return (
                    <div className="row d-flex align-items-center mt-2" key={idx}>
                      <div className="col">
                        <span className="clickable">{accountDetails.accountName}</span>
                      </div>
                      <div className="col text-right">
                        <Button
                          color="danger"
                          onClick={(e) => handleRemoveAccount(accountId, e)}
                        >
                          <i className="fa fa-times"></i>
                        </Button>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
        <div className='d-flex justify-content-end align-items-center mb-3'>
          <div>
            <Button color="secondary" onClick={accountsToggleModal}><Trans>Cancel</Trans></Button>{' '}
            <Button color="primary" onClick={saveSelectedAccounts}><Trans>Save</Trans></Button>
          </div>
          <div>
          </div>
        </div>
      </Modal>
    </Page>
  );
};

const loadReport = (item, xero) => {
  return xero.get("reports/BalanceSheet", {
    params: {
      extra_params: item,
    },
  }).then((res) => res.data);
}

export const enhance = compose(
  withDefaultReportParams(() => ({
    date: formatDate(moment().endOf("month")),
    periods: 1,
    timeframe: "YEAR",
  })),
  onMount(({ xero, item }) => () => {
    return Promise.props({
      data: loadReport(item, xero),
      item,
    });
  }),
  withPropsOnChange(["t"], ({ t }) => ({
    periods: range(1, 11 + 1).map((i) => ({ label: i, value: i })),
    timeframes: [
      ["MONTH", t("Month")],
      ["QUARTER", t("Quarter")],
      ["YEAR", t("Year")],
    ].map(([value, label]) => ({ label, value })),
  })),
  withHandlers({
    handleFilterSubmit:
      ({ setState, xero, dispatch, setReportParams }) =>
        (item) => {
          setReportParams(item);
          return loadReport(item, xero)
            .then((data) => setState({ data }))
            .finally(() => dispatch(actions.setSubmitted("local", true)));
        },
  })
);

export default enhance(AuditRequirements);
